  import {Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';
  import {Observable} from 'rxjs';
  import {ActivatedRoute, Router} from '@angular/router';
  import {Store} from '@ngrx/store';
  import {AppState, selectAuthState, selectDoctorState} from '../../../../store/app.states';
  import {MatDialog} from '@angular/material/dialog';
  import * as _moment from 'moment';
  import {DoctorService} from '../../../../services/doctor.service';


@Component({
  selector: 'app-stable-unstable-malattia-iniziale-section',
  templateUrl: './stable-unstable-malattia-iniziale-section.component.html',
  styleUrls: ['./stable-unstable-malattia-iniziale-section.component.css']
})
export class StableUnstableMalattiaInizialeSectionComponent implements OnInit {



      
          getAuthState: Observable<any>;
          isAuthenticated: boolean;
          user = null;
          errorMessage = null;
          title = 'Pazienti stabili/instabili per Malattia iniziale attiva'; // titolo generale
          destination = 'general-status';
        
          // servono per la comparsa/scomparsa di componenti nella pagina web
          isDataAvailable = true;
          getDoctorState: Observable<any>;
        
          constructor(private router: Router,
            private store: Store<AppState>,
            private doctorService: DoctorService,
            public dialog: MatDialog) {
        this.getAuthState = this.store.select(selectAuthState);
        this.getDoctorState = this.store.select(selectDoctorState);
        }
        
          ngOnInit(): void {
            this.getAuthState.subscribe((state) => {
              this.isAuthenticated = state.isAuthenticated;
              this.user = JSON.parse(localStorage.getItem('user'));
              this.errorMessage = state.errorMessage;
            });
          }
        
        }
        